import { render, staticRenderFns } from "./orderProjectFilter.vue?vue&type=template&id=0f4730f8&scoped=true"
import script from "./orderProjectFilter.vue?vue&type=script&lang=js"
export * from "./orderProjectFilter.vue?vue&type=script&lang=js"
import style0 from "./orderProjectFilter.vue?vue&type=style&index=0&id=0f4730f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4730f8",
  null
  
)

export default component.exports